'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var mylog = {
  init: function init() {
    var _this = this;

    this.send();

    utils.ready(function () {
      _this.initAttrLog();
    });
  },

  /**
   * 初始化属性log
   */
  initAttrLog: function initAttrLog() {
    var _this2 = this;

    var name = 'data-mylog';

    utils.on(document.body, 'click', function (event) {
      var target = event.target;


      while (!target.getAttribute(name) && target.tagName !== 'BODY') {
        target = target.parentElement;
      }

      if (target.tagName !== 'BODY') {
        _this2.send(target.getAttribute(name));
      }
    });
  },

  /**
   * 自定义事件名字，不传参数
   * @param {string} name 发送事件名字
   * @param {object} param 参数
   * @config {string} source 来源
   */
  send: function send(name, param) {
    var params = {
      et: 'pageview'
    };

    if (name) {
      params = {
        etn: name,
        et: 'event'
      };

      // 自定义事件添加参数
      if (utils.isObject(param)) {
        params = _extends(params, {
          etp: encodeURI(JSON.stringify(param))
        });
      }
    }

    this.sendIMG(params);
  },

  /**
   * 生成唯一ID
   * @return {string}
   */
  unique: function unique() {
    var name = '__MYLOG_UID';
    var uid = _cookie2.default.get(name);

    if (!uid) {
      uid = utils.guid();
      _cookie2.default.set(name, uid, {
        expires: 10 * 12 * 30,
        path: '/'
      });
    }

    return uid;
  },

  /**
   * 会话ID
   * @return {string}
   */
  sessionId: function sessionId() {
    var name = '__MYLOG_SID';
    var sid = _cookie2.default.get(name);

    if (!sid) {
      sid = utils.guid();
      _cookie2.default.set(name, sid, {
        path: '/'
      });
    }

    return sid;
  },

  /**
   * 获取当前链接
   * @return {string}
   */
  getURL: function getURL() {
    return window.location.href;
  },

  /**
   * 获取屏幕尺寸
   * @return {string}
   */
  getScreenSize: function getScreenSize() {
    var width = window.screen.width || 0;
    var height = window.screen.height || 0;
    return width + 'x' + height;
  },

  /**
   * 获取语言
   * @return {string}
   */
  getLanguage: function getLanguage() {
    var type = navigator.appName;
    var lang = '';

    if (type === 'Netscape') {
      lang = navigator.language;
    } else {
      lang = navigator.userLanguage;
    }

    return lang;
  },

  /**
   * 发送图片
   * @param {object} params  url参数
   */
  sendIMG: function sendIMG(params) {
    var host = utils.getProtocol() + '://skynet.iyunbao.com/open/v1/data/1.png';
    var img = new Image();
    var initParam = {
      // 当前页面的链接地址
      url: this.getURL(),
      // 页面标题
      te: document.title,
      // 用户唯一Id，用作UV
      uid: this.unique(),
      // 临时（会话）ID
      sid: this.sessionId(),
      // 请求时间戳
      ts: utils.timestamps(),
      // 语言
      lg: this.getLanguage(),
      // 屏幕宽高
      ds: this.getScreenSize()
    };

    initParam = _extends(initParam, params);

    img.src = '' + host + utils.objectToUrl(initParam);

    img.onload = function () {
      img.onload = null;
    };
  }
};

exports.default = mylog;


// WEBPACK FOOTER //
// ./lib/mylog.js